import React, { useState, useEffect, useCallback } from 'react';
import InputField from '../../component/form/FormInput';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import InputSelect from '../../component/inputSelect/InputSelect';
import BillTable from './components/BillTable';
import './CreatePurchaseBill.scss';
import { toast } from 'react-toastify';
import tooltipIcon from '../../assets/image/tooltip_vendor name.png';
import OpenPOAlert from '../../assets/image/Open PO Alert.svg';
import { fetchVendors } from '../../services/vendor';
import { fetchPurchaseOrders } from '../../services/purchaseOrder';
import { fetchPurchaseBillDetails } from '../../services/purchase_bill';
import ConvertToBillModal from '../purchaseOrder/components/ConvertToBillModal';
import { fetchPurchaseReceive } from '../../services/purchase_receive';
import { getCurrentDate, getDate } from '../../utils/dateUtils';
import VendorDetailsDrawer from '../purchaseOrder/components/VendorDetailsDrawer';
import AddVendorModal from '../purchaseOrder/AddNewVendor';
import EWayBillForm from './components/EWayBillForm';
import AddEWayBillFormModal from './components/AddEWayBillFormModal';
import AddTransportModal from './components/AddTransportModal';
import AddPaymentMethodModal from './components/AddPaymentMethodModal';
import usePaymentMethod from './hooks/usePaymentMethod';
import DateConfirmationModal from './components/DateConfirmationModal';
import PurchaseOrderMoreInfoSidebar from './components/PurchaseOrderMoreInfoSidebar';
import TotalBillFooter from './components/TotalBillFooter';
import CreatePurchaseBillHeader from './components/CreatePurchaseBillHeader';
import { addDays, format, parseISO } from 'date-fns';

const CreatePurchaseBill = () => {
	const param = useParams();
	const id = param?.id;
	const navigate = useNavigate();
	const [autofocus, setAutofocus] = useState(false);
	const [isErrortable, setIsTableError] = useState(false);
	const [disabled, setDisabled] = useState(false); //id ? true : false
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	const [isConvetToBillOpen, setIsConvertToBillOpen] = useState(false);
	const [isAddNewVendorModalOpen, setIsAddNewVendorModalOpen] = useState(false);
	const [isAddPaymentMethod, setIsAddPaymentMethod] = useState(false);
	const [isTransportType, setIsTransportType] = useState(false);
	const [error, setError] = useState({});
	const [errorEwayBill, setErrorEwayBill] = useState({});
	const [errorCells, setErrorCells] = useState([]);
	const [vendorDetailsDrawerActiveOpenTab, setVendorDetailsDrawerActiveOpenTab] = useState('');
	const [isVendorDetailsDrawerOpen, setIsVendorDetailsDrawerOpen] = useState(false);
	const [isBillDateFocus, setIsBillDateFocus] = useState(false);
	const [isDateFocus, setIsDateFocus] = useState(false);
	const [isDueDateFocus, setIsDueDateFocus] = useState(false);
	const [isBillNoFocus, setIsBillNoFocus] = useState(false);
	const [isTransportFocus, setIsTransportFocus] = useState(false);
	const [isPaymentMethodFocus, setIsPaymentMethodFocus] = useState(false);
	const [purchaseOrderDetails, setPurchaseOrderDetails] = useState(null);
	const [isEWayBillStatus, setIsEWayBillStatus] = useState(false);
	const [isBillModalOpen, setIsBillModalOpen] = useState(false);
	const [searchVendor, setSearchVendor] = useState('');
	const { paymentMethodList, setSearchPaymentMethod } = usePaymentMethod();
	const [isOpenPastDate, setIsOpenPastDate] = useState(false);
	const [isUsedPastDate, setIsUsedPastDate] = useState(false);
	const [isOpenPBPastDate, setIsOpenPBPastDate] = useState(false);
	const [isUsedPBPastDate, setIsUsedPBPastDate] = useState(false);
	const [isResetTable, setIsResetTable] = useState(false);
	const [subTotal, setSubTotal] = useState(0);
	const [projectTitle, setProjectTitle] = useState('Create New Purchase Bill');
	const [additionDiscountAndTax, setAdditionDiscountAndTax] = useState({
		discount: '',
		adj: '',
		roundOff: '',
		taxes: 0,
	});
	const [inputSelectOption, setInputSelectOption] = useState({
		vendorList: [],
		purchaseOrderIdList: [],
	});

	const location = useLocation();
	const [purchaseBillFormData, setPurchaseBillFormData] = useState({
		vendor_id: '',
		purchase_order_number: '',
		purchase_order_id: '',
		purchase_receive_id: '',
		date: getCurrentDate(),
		bill_number: '',
		bill_date: getCurrentDate(),
		due_date: '',
		bill_amount: '',
		payment_method: '',
		other_adjustment: '',
		purchase_bill_products: [],
		e_way_bill: {
			e_way_bill_no: '',
			challan_no: '',
			date: getCurrentDate(),
			transport: '',
			cases: '',
			purchase_tax: '',
			remarks: '',
			e_way_bill_status: false,
		},
	});
	const [params, setParams] = useState({
		vendor: {
			page: 1,
			pageSize: 20,
			orderBy: null,
			sortBy: null,
			filterBy: null,
			filterValue: null,
			status: 1,
			filter: {
				status: '1',
			},
		},
		purchaseOrder: {
			page: 1,
			pageSize: 1000,
			orderBy: null,
			sortBy: null,
			filterBy: null,
			filterValue: null,
			dropdownList: 'purchase_bill',
		},
	});

	const confirmUsedPastDate = () => {
		const newError = { ...error };
		delete newError.date;
		setError(newError);
		setIsUsedPastDate(true);
		setIsOpenPastDate(false);
		setIsBillDateFocus(true);
	};

	const confirmUsedPBPastDate = () => {
		const newError = { ...error };
		delete newError.bill_date;
		setError(newError);
		setIsUsedPBPastDate(true);
		setIsOpenPBPastDate(false);
		setIsDueDateFocus(true);
	};

	const cancelUsedPastDate = () => {
		if (isOpenPastDate) {
			setIsOpenPastDate(false);
			setIsDateFocus(true);
		} else {
			setIsOpenPBPastDate(false);
			setIsBillDateFocus(true);
		}
	};

	function handleResetPurchaseBillFormData() {
		setPurchaseBillFormData({
			vendor_id: null,
			purchase_order_number: '',
			purchase_order_id: null,
			purchase_receive_id: null,
			date: getCurrentDate(),
			bill_number: '',
			bill_date: getCurrentDate(),
			due_date: '',
			bill_amount: '0.00',
			payment_method: 'Cash',
			other_adjustment: '',
			purchase_bill_products: [],
			e_way_bill: {
				e_way_bill_no: '',
				challan_no: '',
				due_date: '',
				transport: '',
				cases: '',
				purchase_tax: '',
				remarks: '',
				e_way_bill_status: false,
			},
		});
		setParams({
			vendor: {
				page: 1,
				pageSize: 20,
				orderBy: null,
				sortBy: null,
				filterBy: null,
				filterValue: null,
				status: 1,
			},
			purchaseOrder: {
				page: 1,
				pageSize: 20,
				orderBy: null,
				sortBy: null,
				filterBy: null,
				filterValue: null,
			},
		});
	}

	async function updateDueDateByVendorId(vendorId) {
		try {
			const { vendors } = await fetchVendors({
				status: 1,
				page: 1,
				pageSize: 20,
				filterBy: 'vendor_id',
				filterValue: vendorId,
			});
			let vendor = vendors[0];
			const billDate = purchaseBillFormData?.bill_date
				? parseISO(purchaseBillFormData.bill_date)
				: new Date();
			const paymentTermsStr = vendor?.vendor_other_details?.payment_terms || '';
			const cleanedPaymentTerms = paymentTermsStr.replace(/^Net\s*/i, '');
			const paymentTerms = cleanedPaymentTerms ? Number(cleanedPaymentTerms) : 0;
			const dateString = addDays(billDate, paymentTerms);
			const dueDate = format(dateString, 'yyyy-MM-dd');
			setPurchaseBillFormData((prev) => ({
				...prev,
				due_date: dueDate,
			}));
		} catch (error) {
			toast.error(error + ' Something went wrong!');
		}
	}

	//TODO: change form data
	function handleFormData(key, value) {
		let val = '';
		if (key === 'bill_amount') {
			val = value?.replace(/[^0-9.]/g, '');
			const decimalCount = (val.match(/\./g) || []).length;
			if (decimalCount > 1) {
				val = +val?.slice(0, val.lastIndexOf('.'));
			}
		}
		setPurchaseBillFormData((prev) => ({
			...prev,
			[key]: key === 'bill_amount' ? val : value,
		}));
		checkFormValidation(key, key === 'bill_amount' ? val : value);
	}
	function handleKeyPress(event, name) {
		let { value } = event.target;
		if (event.key === 'Enter' || event.key === 'Tab') {
			handleFormData(name, value);
		}
	}

	const checkFormValidation = (type, value) => {
		let errorData = { ...error };
		let errorEWayBillData = { ...errorEwayBill };
		if (value) {
			if (type === 'vendor_id') {
				delete errorData.vendor_id;
			} else if (type === 'purchase_order_id') {
				delete errorData.purchase_order_id;
			} else if (type === 'bill_number') {
				delete errorData.bill_number;
			} else if (type === 'bill_date') {
				delete errorData.bill_date;
			} else if (type === 'bill_amount') {
				delete errorData.bill_amount;
			} else if (type === 'payment_method') {
				delete errorData.payment_method;
			} else if (type === 'date') {
				delete errorData.date;
			} else if (type === 'E-way-bill-no') {
				delete errorEWayBillData.e_way_bill_no;
			} else if (type === 'challan-no') {
				delete errorEWayBillData.challan_no;
			} else if (type === 'due-date') {
				delete errorEWayBillData.due_date;
			} else if (type === 'transport') {
				delete errorEWayBillData.transport;
			} else if (type === 'cases') {
				delete errorEWayBillData.cases;
			} else if (type === 'purchase-tax') {
				delete errorEWayBillData.purchase_tax;
			}
		} else {
			if (type === 'vendor_id') {
				errorData.vendor_id = 'Please select a valid vendor from the list.';
			} else if (type === 'purchase_order_id') {
				errorData.purchase_order_id = 'Please select a purchase order number from the list.';
			} else if (type === 'bill_number') {
				errorData.bill_number = 'Please enter bill number in the field';
			} else if (type === 'bill_date') {
				errorData.bill_date = 'Please enter bill date in the field';
			} else if (type === 'bill_amount') {
				errorData.bill_amount = 'Please enter bill amount in the field';
			} else if (type === 'payment_method') {
				errorData.payment_method = 'Please select a valid Payment method from the list.';
			} else if (type === 'date') {
				errorData.date = 'Please enter date in the field';
			} else if (type === 'E-way-bill-no') {
				errorEWayBillData.e_way_bill_no = 'Please enter e-way bill number in the field';
			} else if (type === 'challan-no') {
				errorEWayBillData.challan_no = 'Please enter challan number in the field';
			} else if (type === 'due-date') {
				errorEWayBillData.due_date = 'Please enter e-way due date in the field';
			} else if (type === 'transport') {
				errorEWayBillData.transport = 'Please enter transport in the field';
			} else if (type === 'cases') {
				errorEWayBillData.cases = 'Please enter cases in the field';
			} else if (type === 'purchase-tax') {
				errorEWayBillData.purchase_tax = 'Please enter purchase tax in the field';
			}
		}
		setError(errorData);
		setErrorEwayBill(errorEWayBillData);
	};

	const calculateTotalBill = () => {
		return (
			Number(subTotal) -
			(Number(subTotal) * Number(additionDiscountAndTax.discount)) / 100 +
			Number(purchaseBillFormData?.other_adjustment ?? 0) +
			additionDiscountAndTax.taxes
		);
	};

	//TODO: fetching vendor list
	const handleFetchVendorList = useCallback(async () => {
		try {
			const { vendors } = await fetchVendors(params?.vendor);
			const vendorOptionList = vendors?.map((vendor) => {
				return {
					key: vendor?.vendor_id,
					value: vendor?.vendor_name,
				};
			});
			setInputSelectOption((prev) => ({
				...prev,
				vendorList: vendorOptionList,
				purchaseOrderIdList: [],
			}));
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}, [params?.vendor]);

	//TODO: fetching purchase order number list according to the vendor id
	const handleFetchPurchaseOrders = useCallback(async () => {
		try {
			if (!purchaseBillFormData?.vendor_id) return;
			const { purchaseOrders } = await fetchPurchaseOrders({
				...params?.purchaseOrder,
				filterBy: 'vendor_id',
				filterValue: purchaseBillFormData?.vendor_id,
			});

			const purchaseOrderIdList =
				purchaseOrders?.length > 0
					? purchaseOrders.map((po) => {
							return {
								key: po.purchase_order_id,
								value: po.purchase_order_number,
							};
						})
					: [];

			setInputSelectOption((prev) => ({
				vendorList: inputSelectOption.vendorList,
				purchaseOrderIdList: purchaseOrderIdList,
			}));
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}, [purchaseBillFormData.vendor_id]);

	function generatePurchaseBillProducts(products, type) {
		const purchase_bill_products = products.reduce((acc, product) => {
			acc.push({
				product_id: product?.product_id,
				batch_no: '',
				quantity:
					type === 'received'
						? product?.received_quantity || 0
						: Number(product?.order_quantity) - Number(product?.received_quantity) || 0,
				mfg_date: '',
				exp_date: '',
				mrp: 0,
				purchase_rate: 0,
				discount: '',
				amount: 0,
				free_quantity: 0,
				product_tax1: Number(product?.product?.tax1),
				product_tax2: Number(product?.product?.tax2),
			});
			return acc;
		}, []);
		return purchase_bill_products;
	}

	async function handleConvertToBill(type, ids) {
		setIsBillNoFocus(true);
		if (type === 'yetToReceive') {
			handleFetchPurchaseOrdersForYTR(ids[0]);
		}

		if (type === 'received') {
			fetchPR(ids[0]);
		}
	}

	const fetchPR = useCallback(
		async (id) => {
			const { purchaseReceive } = await fetchPurchaseReceive({
				filterBy: 'purchase_receive_id',
				filterValue: id,
			});
			setInputSelectOption((prev) => ({
				...prev,
				vendorList: [
					{
						key: purchaseReceive[0]?.vendor?.vendor_id,
						value: purchaseReceive[0]?.vendor?.vendor_name,
					},
				],
				purchaseOrderIdList: [
					{
						key: purchaseReceive[0]?.purchase_order?.purchase_order_id,
						value: purchaseReceive[0]?.purchase_order?.purchase_order_number,
					},
				],
			}));
			setPurchaseBillFormData((prev) => ({
				...prev,
				purchase_receive_id: purchaseReceive[0]?.purchase_receive_id,
				vendor_id: purchaseReceive[0]?.vendor_id,
				purchase_order_number: purchaseReceive[0]?.purchase_order?.purchase_order_number,
				purchase_order_id: purchaseReceive[0]?.purchase_order_id,
				purchase_bill_products: generatePurchaseBillProducts(
					purchaseReceive[0].purchase_receive_products,
					'received',
				),
			}));
			updateDueDateByVendorId(purchaseReceive[0]?.vendor?.vendor_id);
		},
		[id],
	);

	const handleFetchPurchaseOrdersForYTR = useCallback(
		async (id) => {
			const { purchaseOrders } = await fetchPurchaseOrders({
				filterBy: 'purchase_order_id',
				filterValue: Number(id),
			});
			const purchaseOrderDetails = purchaseOrders[0];
			const purchase_bill_products = generatePurchaseBillProducts(
				purchaseOrderDetails.purchase_order_products.filter(
					(product) => product.order_quantity !== product.received_quantity,
				),
				'ytr',
			);
			setInputSelectOption((prev) => ({
				...prev,
				vendorList: [
					{
						key: purchaseOrderDetails?.vendor?.vendor_id,
						value: purchaseOrderDetails?.vendor?.vendor_name,
					},
				],
				purchaseOrderIdList: [
					{
						key: purchaseOrderDetails?.purchase_order_id,
						value: purchaseOrderDetails?.purchase_order_number,
					},
				],
			}));
			setPurchaseOrderDetails(purchaseOrderDetails);
			setPurchaseBillFormData((prev) => ({
				...prev,
				purchase_bill_products: purchase_bill_products,
				vendor_id: purchaseOrderDetails?.vendor_id,
				purchase_order_number: purchaseOrderDetails?.purchase_order_number,
				purchase_order_id: purchaseOrderDetails?.purchase_order_id,
			}));
			updateDueDateByVendorId(purchaseOrderDetails?.vendor_id);
		},
		[id],
	);

	const handleCancelConvertToBill = () => {
		setIsConvertToBillOpen(false);
		setPurchaseBillFormData((prev) => ({
			...prev,
			purchase_order_id: null,
			purchase_order_number: '',
		}));
	};

	const handleBillTotal = useCallback(
		(purchase_bill_products) => {
			const subTotalAmount = purchase_bill_products?.reduce(
				(sum, item) => Number(sum) + Number(item.amount),
				0,
			);
			let totalTax1 = purchase_bill_products?.reduce(
				(sum, item) =>
					Number(sum) + (Number(item.amount ?? 0) * Number(item.product_tax1 ?? 0)) / 100,
				0,
			);
			let totalTax2 = purchase_bill_products?.reduce(
				(sum, item) =>
					Number(sum) + (Number(item.amount ?? 0) * Number(item.product_tax2 ?? 0)) / 100,
				0,
			);

			setAdditionDiscountAndTax((prev) => ({
				...prev,
				taxes: Number(totalTax1) + Number(totalTax2),
			}));
			setSubTotal(Number(subTotalAmount));
		},
		[purchaseBillFormData?.purchase_bill_products],
	);

	const handleFetchPurchaseBillById = useCallback(
		async (id) => {
			const purchaseBillDetails = await fetchPurchaseBillDetails(id);
			const {
				purchase_bill_products,
				e_way_bill,
				vendor_id,
				purchase_order_number,
				purchase_order_id,
				purchase_receive_id,
				date,
				bill_number,
				bill_date,
				due_date,
				bill_amount,
				payment_method,
				discount,
				freight,
				other_adjustment,
				purchase_bill_id,
			} = purchaseBillDetails;

			const updatedVendorList = [
				{
					key: purchaseBillDetails?.vendor?.vendor_id || vendor_id,
					value: purchaseBillDetails?.vendor?.vendor_name,
				},
			];
			const updatedPurchaseOrderList = [
				{
					key: purchase_order_id,
					value:
						purchase_order_number || purchaseBillDetails?.purchase_order?.purchase_order_number,
				},
			];

			setInputSelectOption((prev) => ({
				...prev,
				vendorList: updatedVendorList,
				purchaseOrderIdList: updatedPurchaseOrderList,
			}));

			setPurchaseBillFormData({
				purchase_bill_products:
					purchase_bill_products.length === 0
						? []
						: purchase_bill_products?.map((p) => {
								return {
									...p,
									mfg_date:
										p.mfg_date !== '' && p.mfg_date !== null
											? getDate(p.mfg_date, false, false, true)
											: '',
									exp_date:
										p.exp_date !== '' && p.exp_date !== null
											? getDate(p.exp_date, false, false, true)
											: '',
									product_tax1: Number(p?.product?.tax1),
									product_tax2: Number(p?.product?.tax2),
								};
							}),
				e_way_bill: {
					...e_way_bill,
					date: getDate(e_way_bill?.date, true),
				},
				vendor_id,
				purchase_receive_id,
				purchase_order_number,
				purchase_order_id,
				date: date ? getDate(date, true) : null,
				bill_number,
				bill_date: bill_date ? getDate(bill_date, true) : null,
				due_date: due_date ? getDate(due_date, true) : null,
				bill_amount,
				payment_method,
				discount,
				freight,
				other_adjustment,
				purchase_bill_id,
			});

			if (e_way_bill && e_way_bill?.e_way_bill_no) {
				setIsEWayBillStatus(true);
			}
		},
		[id],
	);

	useEffect(() => {
		let timer = setTimeout(() => {
			setParams((prev) => ({
				...prev,
				vendor: {
					...prev.vendor,
					filterBy: 'vendor_name',
					filterValue: searchVendor,
					status: 1,
				},
			}));
		}, 500);
		return () => clearTimeout(timer);
	}, [searchVendor]);

	useEffect(() => {
		if (!purchaseBillFormData.vendor_id && !id) {
			handleFetchVendorList();
		}
	}, [params.vendor, id, purchaseBillFormData.vendor_id]);

	useEffect(() => {
		if (purchaseBillFormData.vendor_id && !id) {
			handleFetchPurchaseOrders();
		}
	}, [purchaseBillFormData.vendor_id, id]);

	useEffect(() => {
		if (id) {
			if (id.includes('pr') || id.includes('por')) {
				fetchPR(id.split('-')[1]);
			} else if (id.includes('ytr')) {
				handleFetchPurchaseOrdersForYTR(id.split('-')[1]);
			} else {
				handleFetchPurchaseBillById(id);
				setProjectTitle('Update Purchase Bill');
			}
		}
	}, [id]);

	async function handleFetchPurchaseOrderDetails() {
		try {
			const { purchaseOrders } = await fetchPurchaseOrders({
				filterBy: 'purchase_order_id',
				filterValue: purchaseBillFormData?.purchase_order_id,
			});
			const purchaseOrderDetails = purchaseOrders[0];
			setPurchaseOrderDetails(purchaseOrderDetails);
			setPurchaseBillFormData((prev) => ({
				...prev,
				vendor_id: purchaseOrderDetails?.vendor_id,
				purchase_order_number: purchaseOrderDetails?.purchase_order_number,
				purchase_order_id: purchaseOrderDetails?.purchase_order_id,
			}));
			setInputSelectOption((prev) => ({
				...prev,
				vendorList: [
					{
						key: purchaseOrderDetails?.vendor?.vendor_id,
						value: purchaseOrderDetails?.vendor?.vendor_name,
					},
				],
				purchaseOrderIdList: [
					{
						key: purchaseOrderDetails?.purchase_order_id,
						value: purchaseOrderDetails?.purchase_order_number,
					},
				],
			}));
			setIsBillNoFocus(false);
			setIsConvertToBillOpen(true);
		} catch (error) {
			toast.error('Something went wrong!');
		}
	}

	useEffect(() => {
		if (purchaseBillFormData?.purchase_order_id && !id) {
			handleFetchPurchaseOrderDetails();
		}
	}, [purchaseBillFormData?.purchase_order_id, id]);

	useEffect(() => {
		if (purchaseBillFormData?.purchase_bill_products?.length > 0) {
			handleBillTotal(purchaseBillFormData?.purchase_bill_products);
		}
	}, [purchaseBillFormData?.purchase_bill_products]);

	const handleTableDataChange = useCallback(
		(data) => {
			setPurchaseBillFormData((prev) => {
				if (JSON.stringify(prev.purchase_bill_products) !== JSON.stringify(data)) {
					return { ...prev, purchase_bill_products: data };
				}
				return prev;
			});

			handleBillTotal(data);
		},
		[setPurchaseBillFormData, handleBillTotal],
	);

	function setVendorData() {
		if (location && location?.state) {
			const state = location?.state;
			setInputSelectOption((prev) => ({
				...prev,
				vendorList: [{ key: Number(state.key), value: state.value }],
			}));
			setPurchaseBillFormData((prev) => ({
				...prev,
				vendor_id: Number(state?.key),
			}));
			updateDueDateByVendorId(state?.key);
		}
	}

	useEffect(() => {
		if (location && location?.state) {
			setVendorData();
		}
	}, [location]);

	useEffect(() => {
		document.title = `${projectTitle} | Pharmnex`;
	}, [projectTitle]);

	useEffect(() => {
		if (!autofocus) {
			setAutofocus(true);
		}
	}, [autofocus]);

	return (
		<div>
			<div className="">
				<CreatePurchaseBillHeader
					error={error}
					setError={setError}
					errorCells={errorCells}
					setErrorCells={setErrorCells}
					purchaseBillFormData={purchaseBillFormData}
					calculateTotalBill={calculateTotalBill}
					tableError={isErrortable}
				/>
				{/*  Vendor Form */}
				<div
					className="max-w-1297"
					style={{ padding: '1rem 2rem 0' }}
				>
					<div className="row">
						<div className="col-6">
							<InputSelect
								options={inputSelectOption.vendorList}
								label="Vendor Name"
								placeholder="Vendor Name"
								name="vendor_name"
								required={true}
								returnInputValue={false}
								value={purchaseBillFormData?.vendor_id}
								onSelect={(option) => {
									if (option.key !== purchaseBillFormData.vendor_id) {
										setPurchaseBillFormData((prev) => ({
											...prev,
											vendor_id: option.key,
											purchase_order_id: null,
											purchase_order_number: '',
											purchase_bill_products: [],
										}));
										setAdditionDiscountAndTax((prev) => ({
											...prev,
											discount: 0,
										}));
										setIsResetTable(false);
									}
									checkFormValidation('vendor_id', option.key);

									updateDueDateByVendorId(option.key);
								}}
								onChange={(value) => {
									if (value === '') {
										setPurchaseBillFormData((prev) => ({
											...prev,
											vendor_id: null,
											purchase_order_id: null,
											purchase_order_number: '',
										}));
										setIsResetTable(true);

										checkFormValidation('vendor_id', '');
										setAdditionDiscountAndTax((prev) => ({
											...prev,
											discount: 0,
										}));
									}
									setSearchVendor(value);
								}}
								disabled={id ? true : false}
								error={error?.vendor_id}
								autoFocus={autofocus}
								leftIcons={
									purchaseBillFormData?.vendor_id
										? [
												{
													src: OpenPOAlert,
													alt: 'showVendorDetails',
													onClick: () => {
														setVendorDetailsDrawerActiveOpenTab('Open POs');
														setIsVendorDetailsDrawerOpen(true);
													},
												},
												{
													src: tooltipIcon,
													alt: 'Icon 2',
													onClick: () => {
														setVendorDetailsDrawerActiveOpenTab('Details');
														setIsVendorDetailsDrawerOpen(true);
													},
												},
											]
										: []
								}
								onAddNew={() => setIsAddNewVendorModalOpen(true)}
							/>
						</div>
						<div className="col-3">
							<InputSelect
								options={inputSelectOption.purchaseOrderIdList}
								label="PO#"
								placeholder="Purchase Order No"
								name="po"
								required={true}
								moreInfobtn={
									<a
										href="#"
										tabIndex={-1}
										style={{ textDecoration: 'none', fontSize: '11px' }}
										onClick={() => {
											setVendorDetailsDrawerActiveOpenTab('Open POs');
											setIsVendorDetailsDrawerOpen(true);
										}}
									>
										More Info
									</a>
								}
								returnInputValue={false}
								value={purchaseBillFormData?.purchase_order_id}
								onSelect={(option) => {
									setPurchaseBillFormData((prev) => ({
										...prev,
										purchase_order_id: option.key,
										purchase_order_number: option.value,
									}));
									checkFormValidation('purchase_order_id', option.key);
									setAdditionDiscountAndTax((prev) => ({
										...prev,
										discount: 0,
									}));
									setParams((prev) => ({
										...prev,
										purchaseOrder: {
											...prev.purchaseOrder,
											filterBy: 'purchase_order_id',
											filterValue: option.key,
										},
									}));
								}}
								onFocusCb={() => {
									if (purchaseBillFormData?.vendor_id) {
										handleFetchPurchaseOrders();
									}
								}}
								onChange={(value) => {
									if (value === '') {
										setPurchaseBillFormData((prev) => ({
											...prev,
											purchase_order_id: '',
											purchase_order_number: '',
											purchase_bill_products: [],
										}));
										handleFetchPurchaseOrders();
										setAdditionDiscountAndTax((prev) => ({
											...prev,
											discount: 0,
										}));
										return;
									}
									setParams((prev) => ({
										...prev,
										purchaseOrder: {
											...prev.purchaseOrder,
											filterBy: 'purchase_order_number',
											filterValue: value,
										},
									}));
								}}
								error={error?.purchase_order_id}
								disabled={id ? true : false}
							/>
						</div>
						<div className="col-3">
							<InputField
								label="Bill No #"
								placeholder="Bill No #"
								type="text"
								name="bill_no"
								required={true}
								autoFocus={isBillNoFocus}
								onKeyPress={(e) => handleKeyPress(e, 'bill_number')}
								onChange={(value) => handleFormData('bill_number', value)}
								value={purchaseBillFormData.bill_number}
								disabled={disabled}
								error={error?.bill_number}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-3">
							<InputField
								label="Date"
								placeholder="Enter Date"
								name="date"
								max={getCurrentDate()}
								autoFocus={isDateFocus}
								onBlur={(e) => {
									let value = e.target.value;
									let newError = { ...error };
									var date = new Date(value);
									var currentDate = new Date();
									currentDate.setDate(currentDate.getDate() + 1);
									let year = date.getFullYear().toString();
									if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
										if (!isUsedPastDate) {
											setIsOpenPastDate(true);
											setIsDateFocus(false);
											setIsBillDateFocus(false);
											newError.date = 'Date cannot be in the past.';
											setError(newError);
										} else {
											delete newError.date;
											setError(newError);
										}
										setPurchaseBillFormData((prev) => ({
											...prev,
											date: value,
										}));
									} else if (
										year.length === 4 &&
										new Date(value) > currentDate.setHours(0, 0, 0, 0)
									) {
										setIsOpenPastDate(false);
										newError.date = 'Date cannot be in the future';
										setError(newError);
										setPurchaseBillFormData((prev) => ({
											...prev,
											date: value,
										}));
									} else {
										setIsOpenPastDate(false);
										delete newError.date;
										setError(newError);
										setPurchaseBillFormData((prev) => ({
											...prev,
											date: value,
										}));
									}
								}}
								type="date"
								value={purchaseBillFormData.date}
								onChange={(value) => {
									setPurchaseBillFormData((prev) => ({
										...prev,
										date: value,
									}));
								}}
								disabled={disabled}
								required={true}
								error={error?.date}
							/>
						</div>
						<div className="col-3">
							<InputField
								label="Bill Date"
								placeholder="Enter Bill Date"
								name="bill_date"
								onBlur={(e) => {
									let value = e.target.value;
									const newError = { ...error };
									var date = new Date(value);
									var currentDate = new Date();
									currentDate.setDate(currentDate.getDate() + 1);
									let year = date.getFullYear().toString();
									if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
										if (!isUsedPBPastDate) {
											setIsOpenPBPastDate(true);
											setIsBillDateFocus(false);
											setIsDueDateFocus(false);
											newError.bill_date = 'Bill date cannot be in the past.';
											setError(newError);
										} else {
											delete newError.bill_date;
											setError(newError);
										}
										setPurchaseBillFormData((prev) => ({
											...prev,
											bill_date: value,
										}));
									} else if (
										year.length === 4 &&
										new Date(value) > currentDate.setHours(0, 0, 0, 0)
									) {
										setIsOpenPBPastDate(false);
										newError.bill_date = 'Bill date cannot be in the future';
										setError(newError);
										setPurchaseBillFormData((prev) => ({
											...prev,
											bill_date: value,
										}));
									} else {
										setIsOpenPBPastDate(false);
										delete newError.bill_date;
										setError(newError);
										setPurchaseBillFormData((prev) => ({
											...prev,
											bill_date: value,
										}));
									}
								}}
								type="date"
								value={purchaseBillFormData.bill_date}
								onChange={(value) => {
									setPurchaseBillFormData((prev) => ({
										...prev,
										bill_date: value,
									}));
								}}
								max={getCurrentDate()}
								autoFocus={isBillDateFocus}
								required={true}
								disabled={disabled}
								error={error?.bill_date}
							/>
						</div>

						<div className="col-3">
							<InputField
								label="Due Date"
								placeholder="Enter Due Date"
								type="date"
								name="due_date"
								min={getCurrentDate()}
								autoFocus={isDueDateFocus}
								value={purchaseBillFormData.due_date}
								onKeyPress={(e) => {
									let value = e.target.value;
									const newError = { ...error };
									var date = new Date(value);
									let year = date.getFullYear().toString();
									if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
										newError.due_date = 'Due date cannot be in the past.';
										setError(newError);
										setPurchaseBillFormData((prev) => ({
											...prev,
											due_date: value,
										}));
										return;
									}
									if (year.length < 4 || year.length === 4) {
										delete newError.due_date;
										setError(newError);
										setPurchaseBillFormData((prev) => ({
											...prev,
											due_date: value,
										}));
									}
								}}
								onChange={(value) => {
									const newError = { ...error };
									var date = new Date(value);
									let year = date.getFullYear().toString();
									if (year.length === 4 && new Date(value) < new Date().setHours(0, 0, 0, 0)) {
										newError.due_date = 'Due date cannot be in the past.';
										setError(newError);
										setPurchaseBillFormData((prev) => ({
											...prev,
											due_date: value,
										}));
										return;
									}
									if (year.length < 4 || year.length === 4) {
										delete newError.due_date;
										setError(newError);
										setPurchaseBillFormData((prev) => ({
											...prev,
											due_date: value,
										}));
									}
								}}
								error={error?.due_date}
								disabled={disabled}
								required={false}
							/>
						</div>
						<div className="col-3">
							<InputField
								label="Bill Amount"
								name="bill_amount"
								placeholder="0"
								onKeyPress={(e) => handleKeyPress(e, 'bill_amount')}
								type="text"
								value={purchaseBillFormData.bill_amount}
								onChange={(val) => handleFormData('bill_amount', val)}
								disabled={disabled}
								required={true}
								error={error?.bill_amount}
							/>
						</div>
					</div>
					<div
						className="row"
						style={{ justifyContent: 'space-between' }}
					>
						<div className="col-3">
							<InputSelect
								options={paymentMethodList}
								label="Payment Method"
								placeholder="Payment Method"
								required={true}
								name="payment_method"
								autoFocus={isPaymentMethodFocus}
								value={purchaseBillFormData.payment_method}
								onChange={(value) => {
									setSearchPaymentMethod(value);
								}}
								onSelect={(options) => handleFormData('payment_method', options.value)}
								error={error?.payment_method}
								onAddNew={() => {
									setIsAddPaymentMethod(true);
									setIsPaymentMethodFocus(false);
								}}
								disabled={disabled}
							/>
						</div>
						<div className="col-3">
							<InputField
								label="Other Adjustment"
								placeholder="Other Adjustment"
								name="other_adjustment"
								type="number"
								value={purchaseBillFormData.other_adjustment}
								onChange={(value) => handleFormData('other_adjustment', value)}
								disabled={disabled}
							/>
						</div>
					</div>
					<EWayBillForm
						purchaseBillFormData={purchaseBillFormData}
						setPurchaseBillFormData={setPurchaseBillFormData}
						setIsBillModalOpen={setIsBillModalOpen}
					/>
					<br />
				</div>
				{/* Bill Table */}
				<BillTable
					pbId={id}
					tableData={purchaseBillFormData?.purchase_bill_products}
					errorCells={errorCells}
					setErrorCells={setErrorCells}
					isResetTable={isResetTable}
					setTableData={handleTableDataChange}
					disabled={
						purchaseBillFormData.purchase_order_id !== '' &&
						purchaseBillFormData.purchase_order_id !== null
							? true
							: false
					}
					paramId={id}
					tableError={isErrortable}
					setIsTableErrorShow={setIsTableError}
				/>
			</div>

			<TotalBillFooter
				purchase_bill_products={purchaseBillFormData?.purchase_bill_products}
				subTotal={subTotal}
				additionDiscountAndTax={additionDiscountAndTax}
				setSubTotal={setSubTotal}
				setAdditionDiscountAndTax={setAdditionDiscountAndTax}
				calculateTotalBill={calculateTotalBill}
				error={error}
			/>

			{/* Sidebar ka layout */}
			{isSidebarOpen && (
				<PurchaseOrderMoreInfoSidebar
					isSidebarOpen={isSidebarOpen}
					setIsSidebarOpen={setIsSidebarOpen}
				/>
			)}

			{isBillModalOpen && (
				<AddEWayBillFormModal
					isBillModalOpen={isBillModalOpen}
					setIsBillModalOpen={setIsBillModalOpen}
					setPurchaseBillFormData={setPurchaseBillFormData}
					purchaseBillFormData={purchaseBillFormData}
					isEWayBillStatus={isEWayBillStatus}
					setIsEWayBillStatus={setIsEWayBillStatus}
					errorEwayBill={errorEwayBill}
					setErrorEwayBill={setErrorEwayBill}
					isTransportType={isTransportType}
					setIsTransportType={setIsTransportType}
					setIsTransportFocus={setIsTransportFocus}
				/>
			)}
			{isAddNewVendorModalOpen && (
				<AddVendorModal
					handleFormData={handleFormData}
					vendorList={inputSelectOption.vendorList}
					setVendorList={(value) =>
						setInputSelectOption((prev) => ({
							...prev,
							vendorList: value,
						}))
					}
					onClose={() => setIsAddNewVendorModalOpen(false)}
				/>
			)}
			{isConvetToBillOpen && (
				<ConvertToBillModal
					handleCancelConvertToBill={handleCancelConvertToBill}
					isConvertToBillOpen={isConvetToBillOpen}
					setIsConvertToBillOpen={setIsConvertToBillOpen}
					purchaseOrderDetails={purchaseOrderDetails}
					handleConvertToBill={handleConvertToBill}
				/>
			)}

			{(isOpenPastDate || isOpenPBPastDate) && (
				<DateConfirmationModal
					isOpenPastDate={isOpenPastDate}
					isOpenPBPastDate={isOpenPBPastDate}
					cancelUsedPastDate={cancelUsedPastDate}
					confirmUsedPastDate={confirmUsedPastDate}
					confirmUsedPBPastDate={confirmUsedPBPastDate}
				/>
			)}
			{isAddPaymentMethod && (
				<AddPaymentMethodModal
					type={'pb'}
					isAddPaymentMethod={isAddPaymentMethod}
					setIsAddPaymentMethod={setIsAddPaymentMethod}
					setIsPaymentMethodFocus={setIsPaymentMethodFocus}
					setPurchaseBillFormData={setPurchaseBillFormData}
				/>
			)}
			{isTransportType && (
				<AddTransportModal
					isTransportType={isTransportType}
					setIsTransportType={setIsTransportType}
					setIsTransportFocus={setIsTransportFocus}
					setPurchaseBillFormData={setPurchaseBillFormData}
				/>
			)}
			<VendorDetailsDrawer
				isOpen={isVendorDetailsDrawerOpen}
				onClose={() => setIsVendorDetailsDrawerOpen(false)}
				vendor_id={purchaseBillFormData.vendor_id}
				vendorDetailsDrawerActiveOpenTab={vendorDetailsDrawerActiveOpenTab}
			/>
		</div>
	);
};

export default CreatePurchaseBill;
